// extracted by mini-css-extract-plugin
export default {"bubble":"Bubble-module__bubble-PiDsUf","content":"Bubble-module__content-IaJwJm"};